import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const tabs = css`
  min-inline-size: ${spacing(23.75)}; // 190px
`
